import React from 'react'
import { renderOracleMessageHtml, type GaiaDocument } from './gaiaTagParser'

export interface ChatMessageProps {
  /** Additional class names to apply */
  className?: string;
  /** Message text, can be null if user/agent messages aren't in pairs */
  markdown?: string;
  /** When true, links open in the same tab instead of a new tab */
  sameTabLinks?: boolean;
  /** Documents for resolving Gaia tag content links */
  documents?: GaiaDocument[] | null;
}

export const UserMessage = ({
  className = '', markdown, sameTabLinks = false, documents,
}: ChatMessageProps) => {
  const htmlString = renderOracleMessageHtml({
    markdown: markdown || '',
    sameTab: sameTabLinks,
    documents,
  })
  return <div
    className={`oracle-common-message oracle-common-message--user ${className}`}
    dangerouslySetInnerHTML={{ __html: htmlString }}
    />
}

export const AgentMessage = ({
  className = '', markdown, sameTabLinks = false, documents,
}: ChatMessageProps) => {
  const htmlString = renderOracleMessageHtml({
    markdown: markdown || '',
    sameTab: sameTabLinks,
    documents,
  })
  return <div
    className={`oracle-common-message oracle-common-message--agent ${className}`}
    dangerouslySetInnerHTML={{ __html: htmlString }}
    />
}
